# list populated from bitbucket names in server at
# https://bitbucket.org/trello/server/src/b899043498abd922d9a633a7fce88bcf3362ba3f/conf/trellis.defaults.js?fileviewer=file-view-default#trellis.defaults.js-449:465
module.exports = [
    'bb',
    'bb-staging',
    'bb-bello',
    'bb-bello-dev'
]


// WEBPACK FOOTER //
// ./app/scripts/data/emau-embed-whitelist.coffee